<template>
  <main-layout
    customControls
    controlsBg="light"
    :hasControlsBar="true"
    :breadcrumb="getBreadcrumb">
    <div slot="custom-controls-top">
      <div class="controls__filters note">
        <grid-row>
          <grid-col col-size="2">
            <div class="pad">
            <health-explorer-controls
              v-model="selectedDay"
              ref="expControls"
              v-on:input="requestDataInEmit"
              v-on:inputFilter="filterChanged"
              :filters="getFilterOptions"
              :filterValue="getFilterOptions[0]"
            />
            </div>
          </grid-col>
          <grid-col col-size="2">

              <health-explorer-controls-user-select
                v-model="selectedUser"
                v-on:click="requestData"
                v-show="!disableUserSelect"
                v-on:hidden="hiddeComp"
              />

          </grid-col>
          <grid-col col-size="1">
            <btn-pill
              v-has-feature="'Multiboard'"
              class="btn-ok margin-left-l"
              :btnText="$t('health.explorer.multipleBoard.title')"
              btn-type="primary"
              btn-size="xs"
              v-show="!disableUserSelect"
              @click="$router.push({name: 'MultipleBoard'})"/>
          </grid-col>
        </grid-row>
      </div>
    </div>
    <div class="container">
      <div class="header">
        <div class="header__title">
          <h1
            class="flex">
            {{ $t('health.explorer.title') }}
          </h1>
        </div>
      </div>
      <health-chart
        :data="chartData"
      />
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import HealthChart from 'BRAND/components/explorer/HealthChart';
import api from 'BRAND/api/healthExplorer';
import HealthExplorerControls from 'BRAND/components/explorer/HealthExplorerControls';
import HealthExplorerControlsUserSelect from 'BRAND/components/explorer/HealthExplorerControlsUserSelect';
import BtnPill from '@/components/shared/buttons/BtnPill';
import GridCol from '../../../components/shared/grid/GridCol';
import GridRow from '../../../components/shared/grid/GridRow';

export default {
  name: 'HealthExplorer',
  components: {
    GridRow,
    GridCol,
    MainLayout,
    HealthExplorerControls,
    HealthChart,
    HealthExplorerControlsUserSelect,
    BtnPill
  },
  data () {
    return {
      disableUserSelect: false,
      selectedDay: new Date(),
      selectedUser: null,
      selectedFilter: {lable: '', id: 1},
      chartData: null,
      selectedUsers: []
    };
  },
  created () {
    this.requestData();
  },
  computed: {
    getBreadcrumb () {
      return [{name: this.$t('health.explorer.title'), disabled: true}];
    },
    getFilterOptions () {
      let reObj = [{label: this.$t('health.explorer.controls'), id: 1},
        {label: this.$t('health.explorer.controlsDay'), id: 2}];
      return reObj;
    }
  },
  watch: {
    selectedDay () {
      this.requestData();
    }
  },
  methods: {
    requestData () {
      let fromDay;
      let toDay;
      fromDay = this.selectedDay.getTime();
      toDay = fromDay - (7 * 24 * 60 * 60 * 1000);
      // 100 milliseconds of dealy to prevent date selector's UI freezing
      setTimeout(() => {
        if (this.selectedFilter.id === 1) {
          // Week view, las 7 days
          toDay = this.selectedDay.getTime();
          fromDay = toDay - (7 * 24 * 60 * 60 * 1000);
        } else if (this.selectedFilter.id === 2) {
          fromDay = this.selectedDay.getTime() - (18 * 60 * 60 * 1000);
          toDay = this.selectedDay.getTime() + (18 * 60 * 60 * 1000);
        }
        api.getChart(this, fromDay, toDay, this.selectedUser).then(data => {
          if (data.heart_rate) {
            let heartRate = data.heart_rate.sort((a, b) => {
              return a.timestamp - b.timestamp;
            });
            heartRate.forEach((point, i) => {
              if (i === heartRate.length - 1) {
                return;
              }
              if (point.timestamp + 21600000 < heartRate[i + 1].timestamp) {
                data.heart_rate.push({
                  timestamp: point.timestamp + 1,
                  value: -1
                });
                data.heart_rate.push({
                  timestamp: heartRate[i + 1].timestamp - 1,
                  value: -1
                });
              }
            });
          }
          this.chartData = data;
        });
      }, 100);
    },
    getSelectedFilter () {
      return this.getFilterOptions[0];
    },
    hiddeComp () {
      this.disableUserSelect = !this.disableUserSelect;
    },
    requestDataInEmit () {
      if (this.disableUserSelect) {
        this.requestData();
      }
    },
    filterChanged (selectValue) {
      this.selectedFilter = selectValue;
      this.requestDataInEmit();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

.container {
  padding-top: $sp-margin;
  padding-bottom: $sp-margin;
  flex-grow: 1;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.pad {
  padding-right: 16em;
}
.header {
  display: flex;
  justify-content: space-between;

  &__title {
    margin-bottom: $sp-margin;
    @media (min-width: $breakpoint) {
      display: flex;
      h1 {
        margin-bottom: 0;
        margin-right: $sp-margin;
        padding-right: $sp-margin;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/HealthExplorer.vue